import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../shared/icons';
import { formatPrice } from '../../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  loading,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'ime', headerName: t('firstName'), width: 200 },
    { field: 'prezime', headerName: t('lastName'), width: 150 },
    { field: 'email', headerName: t('email'), width: 200 },
    {
      field: 'nazivKategorijeZaposlenog',
      headerName: t('category'),
      width: 200,
    },
    {
      field: 'brutoCena',
      headerName: t('grossPrice'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },

    {
      field: 'inoBrutoCena',
      headerName: t('inoGrossPrice'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'brutoCenaPrekovremena',
      headerName: 'Bruto cena prekovremeno',
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'erpId',
      headerName: 'ERP ID',
      width: 200,
    },
  ];

  return (
    <div style={{ height: '75vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={loading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
};

export default GridProvider;
